import React from 'react';
import PropTypes from 'prop-types';

import {Chip} from 'views/components';
import {translate} from 'views/module';

import contrast from 'css/Contrast';

const ClientStatusView = (props) => {
  const {
    clientData,
    setIsEditing,
  } = props;

  const status = clientData.status;

  const title = translate(`client.Status.${status}.Title`);
  const color = translate(`client.Status.${status}.Color`);
  const textColor = contrast(color);

  return (
    <Chip
      label={title}
      sx={{
        backgroundColor: color,
        color: textColor,
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    />
  );
};

ClientStatusView.propTypes = {
  clientData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientStatusView);
